(function () {
  const playVideo = (swiper) => {
    if (!swiper?.enabled) return;
    const prevSlide = swiper.slides[swiper.previousIndex];
    const activeSlide = swiper.slides[swiper.activeIndex];

    if (activeSlide) {
      // Shopify hosted videos
      activeSlide
        .querySelectorAll("video.slideshow-slide__video")
        .forEach((video) => {
          video.play().catch((error) => {
            console.error("Error playing video:", error);
          });
        });

      // Embedded videos (Youtube or Vimeo)
      activeSlide
        .querySelectorAll("iframe.slideshow-slide__video")
        .forEach((iframe) => {
          if (iframe.classList.contains("js-youtube")) {
            iframe.contentWindow.postMessage(
              '{"event":"command","func":"playVideo","args":""}',
              "*"
            );
          } else if (iframe.classList.contains("js-vimeo")) {
            iframe.contentWindow.postMessage('{"method":"play"}', "*");
          }
        });
    }

    if (prevSlide && prevSlide !== activeSlide) {
      // Shopify hosted videos
      prevSlide
        .querySelectorAll("video.slideshow-slide__video")
        .forEach((video) => {
          video.pause();
        });

      // Embedded videos (Youtube or Vimeo)
      prevSlide
        .querySelectorAll("iframe.slideshow-slide__video")
        .forEach((iframe) => {
          if (iframe.classList.contains("js-youtube")) {
            iframe.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
          } else if (iframe.classList.contains("js-vimeo")) {
            iframe.contentWindow.postMessage('{"method":"pause"}', "*");
          }
        });
    }
  };

  const stopVideo = (swiper) => {
    if (!swiper?.enabled) return;
    const activeSlide = swiper.slides[swiper.activeIndex];

    if (activeSlide) {
      // Shopify hosted videos
      activeSlide
        .querySelectorAll("video.slideshow-slide__video")
        .forEach((video) => {
          video.pause();
        });

      // Embedded videos (Youtube or Vimeo)
      activeSlide
        .querySelectorAll("iframe.slideshow-slide__video")
        .forEach((iframe) => {
          if (iframe.classList.contains("js-youtube")) {
            iframe.contentWindow.postMessage(
              '{"event":"command","func":"pauseVideo","args":""}',
              "*"
            );
          } else if (iframe.classList.contains("js-vimeo")) {
            iframe.contentWindow.postMessage('{"method":"pause"}', "*");
          }
        });
    }
  };

  const CREATIVE_EASE = "cubic-bezier(0.65, 0, 0.35, 1)";
  const CREATIVE_DUR = 1100;
  const PARALLAX_SHIFT = 8; // percent of the media width
  const CONTENT_DUR = 800;
  const CONTENT_OUT_DUR = 600;
  const CONTENT_STAGGER = [100, 200, 300]; // per-child enter delay (ms)
  const UNDERLINE_DELAY = 700; // the label is in place by then, so the line fills under it
  const LEAVING_CLASS = "is-leaving";

  // The wipe is a curtain: the reveal box travels in from one edge while its
  // inner box travels the opposite way, so the slide is uncovered without its
  // content appearing to move. Both are plain transforms — the compositor owns
  // the whole reveal, and a parked slide sits outside its own overflow box, so
  // the browser never paints it.
  const setCurtain = (slide, percent, transition) => {
    const reveal = slide.querySelector(".slideshow-slide__reveal");
    const inner = slide.querySelector(".slideshow-slide__reveal-inner");
    if (!reveal || !inner) return;
    reveal.style.transition = transition;
    inner.style.transition = transition;
    reveal.style.transform = `translateX(${percent}%)`;
    inner.style.transform = `translateX(${-percent}%)`;
  };

  const setMediaTransform = (slide, transition, transform) => {
    const media = slide.querySelector(".slideshow-slide__media-container");
    if (!media) return;
    media.style.transition = transition;
    media.style.transform = transform;
  };

  const creativeDirection = (swiper, intent) => {
    const fallback = intent || "next";
    const count = swiper.slides.length;
    const from = swiper.previousRealIndex;
    const to = swiper.realIndex;
    if (count < 2 || typeof from !== "number" || from === to) return fallback;
    const isNext = to === (from + 1) % count;
    const isPrev = to === (from - 1 + count) % count;
    if (isNext && isPrev) return fallback;
    if (isNext) return "next";
    if (isPrev) return "prev";
    return to > from ? "next" : "prev";
  };

  const endWrapperTransition = (swiper) => {
    const wrapper = swiper.wrapperEl;
    if (!wrapper) return;
    const event =
      typeof TransitionEvent === "function"
        ? new TransitionEvent("transitionend", { propertyName: "transform" })
        : new Event("transitionend");
    wrapper.dispatchEvent(event);
  };

  // Housekeeping between changes, never during one: the slides either side stay
  // open behind the active one — covered, but painted, so the browser keeps
  // their photo decoded and rasterised and the next reveal only moves a layer.
  // Safari drops the render of a slide it has not painted for a while, which is
  // what turned a returning slide into a bare background. Everything further
  // out is parked outside its own box, where it costs nothing.
  const settleSlides = (swiper) => {
    const total = swiper.slides.length;
    if (!total) return;

    const active = swiper.slides[swiper.activeIndex];
    const warm = new Set([
      swiper.slides[(swiper.activeIndex + 1) % total],
      swiper.slides[(swiper.activeIndex - 1 + total) % total],
    ]);

    swiper.slides.forEach((slide) => {
      if (slide === active) return;
      slide.classList.remove(LEAVING_CLASS);
      setCurtain(slide, warm.has(slide) ? 0 : 100, "none");
    });
  };

  const revealSlide = (swiper, active, previous, direction) => {
    const dur = swiper.params.speed || CREATIVE_DUR;
    const sign = direction === "prev" ? -1 : 1;
    const startX = sign * PARALLAX_SHIFT;
    const transition = `transform ${dur}ms ${CREATIVE_EASE}`;

    if (previous && previous !== active) {
      previous.classList.add(LEAVING_CLASS);
      setCurtain(previous, 0, "none");
      setMediaTransform(previous, transition, `translateX(${-startX}%)`);
    }

    if (active) {
      active.classList.remove(LEAVING_CLASS);
      setCurtain(active, sign * 100, "none");
      setMediaTransform(active, "none", `translateX(${startX}%)`);

      void active.offsetWidth;

      setCurtain(active, 0, transition);
      setMediaTransform(active, transition, `translateX(0%)`);
    }
  };

  // Wrap each content child in a clip box so it can slide up/out and in/below
  // without spilling past the line. Idempotent + reversible for theme-editor
  // re-inits (unwrapped on teardown).
  const wrapContentMasks = (section) => {
    section.querySelectorAll(".slideshow-slide__content").forEach((content) => {
      Array.from(content.children).forEach((child) => {
        if (child.classList.contains("slideshow-slide__mask")) return;
        const mask = document.createElement("div");
        mask.className = "slideshow-slide__mask";
        content.insertBefore(mask, child);
        mask.appendChild(child);
      });
    });
  };

  const unwrapContentMasks = (section) => {
    section
      .querySelectorAll(".slideshow-slide__content .slideshow-slide__mask")
      .forEach((mask) => {
        const child = mask.firstElementChild;
        if (child) {
          mask.parentNode.insertBefore(child, mask);
          child.style.transition = "";
          child.style.transform = "";
        }
        mask.remove();
      });
  };

  const resetCreativeStyles = (section) => {
    section.querySelectorAll(".slideshow-slide").forEach((slide) => {
      slide.style.transition = "";
      slide.style.clipPath = "";
      slide.style.webkitClipPath = "";
      slide.classList.remove(LEAVING_CLASS);
    });
    section
      .querySelectorAll(
        ".slideshow-slide__reveal, .slideshow-slide__reveal-inner"
      )
      .forEach((el) => {
        el.style.transition = "";
        el.style.transform = "";
      });
    section
      .querySelectorAll(".slideshow-slide__media-container")
      .forEach((media) => {
        media.style.transition = "";
        media.style.transform = "";
      });
    section.querySelectorAll(".button--tertiary").forEach((btn) => {
      clearTimeout(btn._underlineDelayTimer);
      btn.style.removeProperty("--underline-delay");
    });
  };

  // Text swap: outgoing masked children leave upward, incoming rise from below
  // (staggered). Fully JS-driven so a re-visited slide never inherits a stale
  // inline transform.
  const animateContent = (slide, mode) => {
    if (!slide) return;
    slide.querySelectorAll(".slideshow-slide__mask > *").forEach((el, i) => {
      if (mode === "out") {
        el.style.transition = `transform ${CONTENT_OUT_DUR}ms ${CREATIVE_EASE}`;
        el.style.transitionDelay = "0ms";
        el.style.transform = "translateY(-100%)";
      } else {
        el.style.transition = "none";
        el.style.transform = "translateY(100%)";
        void el.offsetWidth;
        const delay = CONTENT_STAGGER[Math.min(i, CONTENT_STAGGER.length - 1)];
        el.style.transition = `transform ${CONTENT_DUR}ms ${CREATIVE_EASE}`;
        el.style.transitionDelay = delay + "ms";
        el.style.transform = "translateY(0%)";
      }
    });
  };

  // Re-sweep the tertiary button underline on the active slide (draws in
  // left->right, held back until the label has risen); the outgoing slide's
  // underline retracts to the right.
  const resweepUnderline = (slide, active) => {
    if (!slide) return;
    slide.querySelectorAll(".button--tertiary").forEach((btn) => {
      clearTimeout(btn._underlineDelayTimer);
      if (active === true) {
        btn.style.setProperty("--underline-delay", `${UNDERLINE_DELAY}ms`);
        btn._underlineDelayTimer = setTimeout(() => {
          btn.style.removeProperty("--underline-delay");
        }, UNDERLINE_DELAY + 400);
      } else {
        btn.style.removeProperty("--underline-delay");
      }
      btn.classList.toggle("is-underline-active", active === true);
    });
  };

  const initAutoplayObserver = (section, sliderEl) => {
    if (!section || !section?.classList?.contains("slideshow-section")) return;
    if (!sliderEl || !sliderEl.swiper) return;

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        sliderEl._slideshowHold?.set("offscreen", !entry.isIntersecting);
        if (entry.isIntersecting) {
          playVideo(sliderEl.swiper);
        } else {
          stopVideo(sliderEl.swiper);
        }
      });
    });

    sectionObserver.observe(section);
    sliderEl._autoplayObserver = sectionObserver;
  };

  const destroySlideshow = (section) => {
    if (!section || !section?.classList?.contains("slideshow-section")) return;

    if (section._slideshowNavIntent) {
      section.removeEventListener("click", section._slideshowNavIntent, true);
      section._slideshowNavIntent = null;
    }

    section.querySelectorAll(".js-slideshow-swiper").forEach((sliderEl) => {
      if (sliderEl._autoplayObserver) {
        sliderEl._autoplayObserver.disconnect();
        sliderEl._autoplayObserver = null;
      }
      if (sliderEl._slideshowHold) {
        sliderEl._slideshowHold.destroy();
        sliderEl._slideshowHold = null;
      }
      if (sliderEl._slideshowEdgeWheel) {
        sliderEl.removeEventListener("wheel", sliderEl._slideshowEdgeWheel);
        sliderEl._slideshowEdgeWheel = null;
      }
      if (sliderEl.swiper) {
        clearTimeout(sliderEl.swiper._creativeEndTimer);
        sliderEl.swiper.destroy(true, true);
      }
      unwrapContentMasks(sliderEl);
      resetCreativeStyles(sliderEl);
    });
  };

  const initSlideshow = (section) => {
    if (!section || !section?.classList?.contains("slideshow-section")) return;

    const sliderEl = section.querySelector(".js-slideshow-swiper");
    if (!sliderEl) return;

    if (sliderEl._autoplayObserver) {
      sliderEl._autoplayObserver.disconnect();
      sliderEl._autoplayObserver = null;
    }
    if (sliderEl._slideshowHold) {
      sliderEl._slideshowHold.destroy();
      sliderEl._slideshowHold = null;
    }
    if (sliderEl._slideshowEdgeWheel) {
      sliderEl.removeEventListener("wheel", sliderEl._slideshowEdgeWheel);
      sliderEl._slideshowEdgeWheel = null;
    }
    if (sliderEl.swiper) {
      clearTimeout(sliderEl.swiper._creativeEndTimer);
      sliderEl.swiper.destroy(true, true);
    }
    unwrapContentMasks(sliderEl);
    resetCreativeStyles(sliderEl);

    const animationType = sliderEl.dataset?.animationType || "slide";
    const isCreative = animationType === "creative";
    if (isCreative) wrapContentMasks(sliderEl);
    // Creative drives its own clip-path/parallax reveal; Swiper just stacks the
    // slides via the fade effect (opacity is neutralised in CSS).
    const effectType = isCreative ? "fade" : animationType;
    const paginationEl = section.querySelector(".slider-pagination");
    const nextBtn = section.querySelector(".slider-nav-button--next");
    const prevBtn = section.querySelector(".slider-nav-button--prev");
    const sliderLoop = sliderEl.getAttribute("data-loop") === "true";
    const hasSliderAutoplay = sliderEl.getAttribute("data-autoplay") === "true";
    const pauseAutoplayOnHover =
      sliderEl.getAttribute("data-autoplay-pause-on-hover") === "true";
    const autoplayDelay = Number(sliderEl.dataset.autoplayDelay || 5000);
    const hasParallax = sliderEl.getAttribute("data-parallax") === "true";

    section.removeEventListener("click", section._slideshowNavIntent, true);
    section._slideshowNavIntent = (event) => {
      if (event.target.closest(".slider-nav-button--prev")) {
        section._slideshowIntent = "prev";
      } else if (event.target.closest(".slider-nav-button--next")) {
        section._slideshowIntent = "next";
      }
    };
    section.addEventListener("click", section._slideshowNavIntent, true);

    // Creative wraps with `rewind`, not `loop`. Loop mode keeps the active slide
    // centred by re-inserting slides in the DOM, and a re-attached element loses
    // everything the browser had rendered for it — Safari then shows the slide as
    // bare background when it comes round again, which is why the wipe only broke
    // from the second lap on, once every slide had been moved once. Rewind wraps
    // by index alone and never touches the DOM; with slides stacked (not scrolled)
    // the two are indistinguishable on screen.
    const wrapsAround = sliderLoop && isCreative;

    new Swiper(sliderEl, {
      loop: sliderLoop && !isCreative,
      rewind: wrapsAround,
      slidesPerView: 1,
      spaceBetween: 0,
      speed: isCreative ? CREATIVE_DUR : 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      effect: effectType,
      fadeEffect: { crossFade: true },
      resistanceRatio: isCreative ? 0 : 0.85,
      parallax: hasParallax,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: hasSliderAutoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
          }
        : false,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          if (paginationEl) {
            paginationEl.style.setProperty("--slider-progress", 1 - progress);
          }
        },
        touchEnd(s) {
          if (!wrapsAround || !s.swipeDirection) return;
          if (s.swipeDirection === "next" && s.isEnd) {
            s.slideNext();
          } else if (s.swipeDirection === "prev" && s.isBeginning) {
            s.slidePrev();
          }
        },
        slideChangeTransitionStart() {
          playVideo(this);

          if (isCreative) {
            const active = this.slides[this.activeIndex];
            let previous = this._creativePreviousSlide;
            if (previous === active) previous = null;

            const intent = this.swipeDirection || section._slideshowIntent;
            section._slideshowIntent = null;

            revealSlide(
              this,
              active,
              previous,
              creativeDirection(this, intent)
            );
            animateContent(previous, "out");
            animateContent(active, "in");
            resweepUnderline(previous, false);
            resweepUnderline(active, true);
            this._creativePreviousSlide = active;

            // The reveal runs on our own elements, so nothing Swiper listens to
            // ever ends: `animating` would stay stuck (blocking manual nav) and
            // autoplay, which pauses on every change and waits for a
            // transitionend on the wrapper, would never resume. Close both on a
            // timer — the wrapper event goes through Swiper's own resume, so
            // pause-on-hover keeps working.
            clearTimeout(this._creativeEndTimer);
            this._creativeEndTimer = setTimeout(() => {
              if (this.destroyed) return;
              this.transitionEnd();
              endWrapperTransition(this);
              settleSlides(this);
            }, this.params.speed + 50);
          }
        },
      },
    });

    if (hasSliderAutoplay && sliderEl.swiper) {
      sliderEl._slideshowHold = holdSwiperAutoplay(sliderEl.swiper, section, {
        hoverTarget: pauseAutoplayOnHover ? sliderEl : null,
      });
    }

    initAutoplayObserver(section, sliderEl);

    if (wrapsAround && sliderEl.swiper) {
      let lastEdgeWheel = 0;
      sliderEl._slideshowEdgeWheel = (event) => {
        const swiper = sliderEl.swiper;
        if (!swiper || swiper.destroyed || swiper.animating) return;
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        const now = Date.now();
        if (now - lastEdgeWheel < swiper.params.speed) return;
        if (event.deltaX > 0 && swiper.isEnd) {
          lastEdgeWheel = now;
          swiper.slideNext();
        } else if (event.deltaX < 0 && swiper.isBeginning) {
          lastEdgeWheel = now;
          swiper.slidePrev();
        }
      };
      sliderEl.addEventListener("wheel", sliderEl._slideshowEdgeWheel, {
        passive: true,
      });
    }

    if (isCreative && sliderEl.swiper) {
      const swiper = sliderEl.swiper;
      swiper._creativePreviousSlide = swiper.slides[swiper.activeIndex];
      setCurtain(swiper.slides[swiper.activeIndex], 0, "none");
      settleSlides(swiper);

      // Draw the first slide's underline in on paint (matches the mockup's
      // resting underline and the "line appears left->right" intent).
      requestAnimationFrame(() => {
        resweepUnderline(swiper.slides[swiper.activeIndex], true);
      });
    }
  };

  initSlideshow(document.currentScript.parentElement);

  if (!window.__themeSlideshowEvents) {
    window.__themeSlideshowEvents = true;

    document.addEventListener("shopify:section:load", function (event) {
      initSlideshow(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      destroySlideshow(event.target);
    });
  }
})();
